import iconMap from '@/language/pt/utils/iconMap';

export default {
  iconMap,
};
